import React from 'react'

const impactIcons = RAILS_ASSET_URL('/sprites/impact-icons.svg')

export const ImpactIcon = ({ icon, className, ...props }) =>
  <SpriteIcon icon={icon} file={impactIcons} className={className} {...props} />

const SpriteIcon = ({ icon, file, className, ...props }) =>
  <svg
    {...props}
    className={[ 'sprite-icon', className ].filter(Boolean).join(' ')}
  >
    <use href={[ file, icon ].join('#')} />
  </svg>

export default SpriteIcon
